<!--suppress JSUnresolvedVariable -->
<template>
  <div class="mt-4 ml-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">友情链接管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button @click="addFriendLink(0)" size="small" type="primary" plain>
          新增链接
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="friendLinkList"
        tooltip-effect="dark"
        style="width: 100%;"
        height="417"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="friendLinkId"
          label="链接ID"
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column prop="friendLinkName" label="链接名称" align="center">
        </el-table-column>
        <el-table-column prop="friendLinkUrl" label="链接地址" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          sortable
          align="center"
        >
        </el-table-column>
        <el-table-column prop="friendLinkIcon" label="缩略图" align="center">
          <template slot-scope="scope">
            <img
              :src="scope.row.friendLinkIcon"
              width="48"
              height="48"
              alt="缩略图"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="150">
          <template slot-scope="scope">
            <el-button
              @click="editFriendLink(scope.row.friendLinkId)"
              type="primary"
              plain
              size="small"
              >编辑
            </el-button>
            <el-popconfirm
              placement="top"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="deleteById(scope.row.friendLinkId)"
            >
              <el-button
                type="danger"
                slot="reference"
                plain
                class="ml-1"
                size="small"
              >
                移除
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "FriendLinks",
  data() {
    return {
      friendLinkList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.getFriendLinkList();
  },
  methods: {
    getFriendLinkList() {
      this.loading = true;
      this.axios
        .get("/friendLink/getFriendLinkList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.friendLinkList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getFriendLinkList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getFriendLinkList();
    },
    editFriendLink(friendLinkId) {
      this.$router
        .push({
          name: "FriendLinkForm",
          params: { friendLinkId: friendLinkId }
        })
        .catch();
    },
    addFriendLink(friendLinkId) {
      this.$router
        .push({
          name: "FriendLinkForm",
          params: { friendLinkId: friendLinkId }
        })
        .catch();
    },
    deleteById(friendLinkId) {
      this.axios
        .delete("/friendLink/deleteFriendLink", {
          params: {
            friendLinkId: friendLinkId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.getFriendLinkList();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
